import { ConcreteEncodable } from "./ConcreteEncodable";

import { TriggerDetailsImplEncoder } from "../../encoder/TriggerDetailsImplEncoder";

import * as CubiqTS from "../../index";
import { TriggerDetails } from "../TriggerDetails";

export class TriggerDetailsImpl extends ConcreteEncodable implements TriggerDetails {
  public static enType: string = "com.bcdfx.model.event.lifecycle.fx.TriggerDetailsImpl";

  /*FID=100*/
  public messageId: string;
  /*FID=961*/
  public triggerRt: CubiqTS.BigNumber | null = null;
  /*FID=962*/
  public triggerSide: CubiqTS.RateSideType;
  /*FID=963*/
  public triggerRateId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = TriggerDetailsImplEncoder.Instance;
    this.setEncodableType(TriggerDetailsImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "TriggerDetailsImpl[" +
      "messageId=" +
      this.messageId +
      "triggerRt=" +
      this.triggerRt +
      "triggerSide=" +
      this.triggerSide +
      "triggerRateId=" +
      this.triggerRateId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
